<template>
    <CompanyBoxContent v-if="jobPositions && jobPositions.length > 0" :title="$t('company.jobPositions') + ':'">
        <template #data>
            <div class="box p-0">
                <div v-for="(job, index) in jobPositions" :key="index" :class="['p-3 inner', index % 2 === 0 ? 'bg' : '']">
                    <!-- Header -->
                    <div class="d-flex justify-content-center align-items-center text-center">
                        <span>{{ job.data.pozadovanaProfese.cs }}</span>
                    </div>
                    <!-- Button for opening the modal -->
                    <div class="d-flex justify-content-center align-items-center">
                        <button type="button" class="btn btn_main mt-2" data-bs-toggle="modal"
                            data-bs-target="#jobDescription" @click="this.selectedJob = job">
                            {{ $t('company.showJobDescription') }}
                        </button>
                    </div>
                    <!-- Modal -->
                    <Popup :header="$t('company.showJobDescription')" :editable="false" :showButton="false"
                        id="jobDescription">
                        <template #header v-if="selectedJob">
                            <span>{{ selectedJob.data.pozadovanaProfese.cs }}</span>
                        </template>
                        <template #body v-if="selectedJob">
                            <div class="row modal_body">
                                <div>
                                    <span class="me-1">{{ $t('company.insertDate') }}:</span>
                                    <i18n-d tag="span" :value="new Date(selectedJob.data.datumVlozeni)"></i18n-d>
                                </div>
                                <div v-if="selectedJob.data.mesicniMzdaOd">
                                    <span class="me-1">{{ $t('company.wageFrom') }}:</span>
                                    <span>{{ formatAmount(selectedJob.data.mesicniMzdaOd) }}</span>
                                </div>
                                <div v-if="selectedJob.data.mesicniMzdaDo">
                                    <span class="me-1">{{ $t('company.wageTo') }}:</span>
                                    <span>{{ formatAmount(selectedJob.data.mesicniMzdaDo) }}</span>
                                </div>
                                <div v-if="selectedJob.data.typMzdy">
                                    <span class="me-1">{{ $t('company.wageType') }}:</span>
                                    <span>{{ selectedJob.data.typMzdy }}</span>
                                </div>
                                <div v-if="selectedJob.data.pocetMist">
                                    <span class="me-1">{{ $t('company.numberOfPositions') }}:</span>
                                    <span>{{ selectedJob.data.pocetMist }}</span>
                                </div>
                                <div v-if="selectedJob.data.terminZahajeniPracovnihoPomeru">
                                    <span class="me-1">{{ $t('company.startingDate') }}:</span>
                                    <i18n-d tag="span"
                                        :value="new Date(selectedJob.data.terminZahajeniPracovnihoPomeru)"></i18n-d>
                                </div>
                                <div v-if="selectedJob.data.mistoVykonuPrace.pracoviste">
                                    <span class="me-1">{{ $t('company.workplace') }}:</span>
                                    <div v-for="workplace in selectedJob.data.mistoVykonuPrace.pracoviste">
                                        <span>{{ workplace.nazev }}</span>
                                    </div>
                                </div>
                                <div class="row" v-if="selectedJob.data.pracovnePravniVztahy">
                                    <span class="me-1">{{ $t('company.workType') }}:</span>
                                    <span>{{ selectedJob.data.pracovnePravniVztahy.map(vztah => vztah.id).join(', ')
                                        }}</span>
                                </div>
                            </div>
                        </template>
                    </Popup>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>


<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"
import Popup from "@/components/Popup.vue"
export default {
    props: {
        jobPositions: {
            type: Array,
            required: true
        }
    },
    components: {
        CompanyBoxContent,
        Popup
    },
    data() {
        return {
            selectedJob: null
        }
    },
    methods: {
        formatAmount(value) {
            return (
                new Intl.NumberFormat("cs-CZ", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                }).format(value) + " Kč"
            );
        },
    }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.inner {
    border-radius: $radius-lg;
}
.bg {
    background-color: $grey;
}

.modal_body {
    background-color: $white;
    border-radius: $radius-lg;
    padding: 10px 20px;
}
</style>